import { useEffect, useState } from 'react';
import { clampPage } from '@/pages/reader/readerUtils';

interface ReaderFooterControlsProps {
  page: number;
  total: number;
  label: string;
  onJump: (page: number) => void;
}

export default function ReaderFooterControls({ page, total, label, onJump }: ReaderFooterControlsProps) {
  const [input, setInput] = useState(String(page));

  useEffect(() => {
    setInput(String(page));
  }, [page]);

  const submit = () => {
    const n = Number.parseInt(input, 10);
    if (!Number.isNaN(n)) onJump(clampPage(n, total));
    else setInput(String(page));
  };

  return (
    <footer className="z-30 w-full border-t border-primary-800/70 bg-primary-950 px-3 py-3 md:px-6">
      <div className="mx-auto flex w-full max-w-4xl flex-col gap-3 sm:flex-row sm:items-center">
        <span className="min-w-[96px] font-label text-sm font-medium text-accent-300">{label}</span>

        <input
          type="range"
          min={1}
          max={total}
          value={page}
          onChange={(e) => onJump(Number(e.target.value))}
          aria-label="쪽 이동 슬라이더"
          className="h-2 flex-1 cursor-pointer appearance-none rounded-full bg-primary-800 accent-accent-500"
        />

        <div className="flex items-center justify-end gap-2">
          <input
            type="number"
            min={1}
            max={total}
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') submit();
            }}
            aria-label="쪽 번호 직접 입력"
            className="h-11 w-20 rounded-md border border-primary-700 bg-primary-900 px-2 text-center font-label text-base text-background-50 focus:border-accent-500 focus:outline-none"
          />
          <span className="font-label text-sm text-primary-200">쪽</span>
          <button
            type="button"
            onClick={submit}
            className="h-11 whitespace-nowrap rounded-md bg-accent-500 px-4 font-label text-base font-bold text-primary-950 transition-colors hover:bg-accent-400"
          >
            이동
          </button>
        </div>
      </div>
    </footer>
  );
}